"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const InfiniteScroll = require("react-infinite-scroller");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../reducers");
const LoadingIndicator_1 = require("./LoadingIndicator");
const CampaignListItem_1 = require("./CampaignListItem");
const CampaignsList = ({ campaigns = [], media, pushToModal, style, fetchCampaigns, hasNextPage, endCursor, }) => {
    const baseStyle = Object.assign({ width: '100%', paddingLeft: media === 'Mobile' ? 24 : 32, paddingRight: media === 'Mobile' ? 24 : 32, overflowY: 'scroll', backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }, style);
    if (Object.keys(campaigns).length === 0) {
        const emptyRows = new Array(Math.floor(window.innerHeight / 95) - 2).fill(null);
        const skeletonRows = emptyRows.map((_, index) => (React.createElement("div", { key: index, style: {
                width: '100%',
                height: 95,
                backgroundColor: 'white',
                flex: '0 0 auto',
                borderBottom: `1px solid ${src_1.titanium}`,
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    maxWidth: media === 'Desktop' ? 1024 : 1024,
                    margin: 'auto',
                    paddingLeft: media === 'Desktop' ? 32 : 0,
                    paddingRight: media === 'Desktop' ? 32 : 0,
                } }))));
        return React.createElement("div", { style: baseStyle }, skeletonRows);
    }
    return (React.createElement("div", { style: baseStyle },
        React.createElement(InfiniteScroll, { style: { width: '100%' }, loadMore: () => fetchCampaigns(50, endCursor), hasMore: hasNextPage, loader: React.createElement("div", { className: "loader", key: "0", style: {
                    textAlign: 'center',
                    color: src_1.titanium,
                    paddingTop: 33.5,
                    paddingBottom: 33.5,
                } },
                React.createElement(LoadingIndicator_1.default, null)), useWindow: false }, campaigns.map((campaign, index) => (React.createElement(CampaignListItem_1.default, { key: index, campaign: campaign, media: media, pushToModal: (route) => pushToModal(campaign.id, route) }))))));
};
const mapStateToProps = (state, ownProps) => {
    const { campaignStatus, campaignType } = ownProps;
    return {
        campaigns: reducers_1.getOrderedCampaignList(state, campaignStatus, campaignType),
        hasNextPage: reducers_1.getCampaignHasNextPage(state),
        endCursor: reducers_1.getCampaignEndCursor(state),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, {})(CampaignsList);
